'use client';

import Lottie from 'lottie-react';
import * as React from 'react';

import loaderAnimation from './loader.animation.json';

type LoaderProps = {
    className?: string;
    size?: number | string;
};

export function Loader({ className, size = 75 }: LoaderProps) {
    const sizeValue = typeof size === 'number' ? `${size}px` : size;

    return (
        <Lottie
            className={className}
            style={{ width: sizeValue, height: sizeValue }}
            animationData={loaderAnimation}
        />
    );
}
